import React from "react";

export class ImpressumFR extends React.Component {
    render() {
        return (
            <>
                <h3>Responsable du site web</h3>
                <p>DH Healthcare GmbH</p>

                <h3>Siège social et immatriculation</h3>
                <p>Bonn, Tribunal d’instance de Bonn HRB 25633</p>

                <h3>Adresse et contact</h3>
                <p>
                    Konrad-Zuse-Platz 1-3
                    <br />
                    53227 Bonn, Allemagne
                </p>
                <p>
                    Téléphone: +49 (0)228 / 2668 000
                    <br />
                    Fax: +49 (0) 228 / 2668 001
                    <br />
                    E-mail: healthcare.de@dedalus.com
                </p>

                <h3>Représentants légaux</h3>
                <p>
                    M. Dieter Nels
                    <br />
                    M. Daniel Strauch
                    <br />
                    M. Winfried Post
                </p>
            </>
        );
    }
}
